// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Xwxmd6H8nXbby3F8I_zY-{color:var(--text-primary-light);font-size:1.6rem;font-weight:300}@media screen and (min-width:768px){.Xwxmd6H8nXbby3F8I_zY-{font-size:1.8rem}}.Xwxmd6H8nXbby3F8I_zY- div>p{padding-left:0;padding-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rteParserPrimaryLight": "Xwxmd6H8nXbby3F8I_zY-"
};
module.exports = ___CSS_LOADER_EXPORT___;
